export default __webpack_public_path__ + "static/media/beauty1.e958f96b.png";